import React from 'react'
import { Helmet } from 'react-helmet-async'
import { PurgeCacheLayout } from '../../layouts'

const PurgeCachePage = (): React.ReactElement => (
  <React.Fragment>
    <Helmet>
      <title>Purge Cache</title>
      <meta name="description" content="Purge Cache page" />
    </Helmet>
    <PurgeCacheLayout />
  </React.Fragment>
)

export default PurgeCachePage
